import { initializeApp } from "firebase/app";
import {
  AppCheck,
  getToken,
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let appCheck: AppCheck | null = null;

/**
 * Initialize Firebase App Check once at app startup.
 * The SDK generates and auto-refreshes the token.
 */
export const initAppCheck = (): void => {
  if (appCheck || !siteKey) {
    if (!siteKey) console.warn("App Check disabled: REACT_APP_RECAPTCHA_SITE_KEY missing");
    return;
  }

  if (process.env.NODE_ENV === "development") {
    // Prints a debug token in the console to register in Firebase Console (App Check > Manage debug tokens).
    (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
      process.env.REACT_APP_APPCHECK_DEBUG_TOKEN || true;
  }
  const firebaseConfig= {
      apiKey: process.env.REACT_APP_FB_API_KEY,
      projectId: process.env.REACT_APP_FB_PROJECT_ID,
      appId: process.env.REACT_APP_FB_APP_ID,
      authDomain: process.env.REACT_APP_AUTH_DOMAIN,
      storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_MSG_SED_ID
  }

  try {
    const app = initializeApp(firebaseConfig);

    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(siteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    console.error("Failed to initialize App Check:", error);
  }
};

const APP_CHECK_HEADER = "X-Firebase-AppCheck";
const DUMMY_APP_CHECK_TOKEN = "dummy";

/**
 * Returns the `X-Firebase-AppCheck` header for protected APIs.
 * If App Check is unavailable or fails, a dummy token is sent so the header
 * is always present; the backend decides whether to reject it.
 */
export const getAppCheckHeaders = async (): Promise<Record<string, string>> => {
  if (!appCheck) return { [APP_CHECK_HEADER]: DUMMY_APP_CHECK_TOKEN };
  try {
    const { token } = await getToken(appCheck);
    return { [APP_CHECK_HEADER]: token };
  } catch (error) {
    console.error("Failed to get App Check token:", error);
    return { [APP_CHECK_HEADER]: DUMMY_APP_CHECK_TOKEN };
  }
};